import React from 'react'
import { AppState } from '@chegg-wt/core/state'
import { connect } from 'react-redux'

import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import { useRouter } from 'next/router'
import SourceSearch, {
  SourceSearchPageStructureTop,
} from '@chegg-wt/core/components/Layouts/SourceSearch'
import { TopContentWrapper } from '@chegg-wt/core/components/AdFrame/'
import { getLvpLayout } from '@chegg-wt/core/components/Layouts/LargeVideoPlayerLayout'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import { getUrlStyle } from '@chegg-wt/core/server/utils/redirect'
import { getSourceTypeName } from '@chegg-wt/core/utils/sourceTypes'
import { currentStyleSelector } from '@chegg-wt/core/state/currentProject/selectors'
import { lvpLayoutSelector } from '@chegg-wt/core/state/featureFlags/selectors'
import { getCapitalizedSEONameOfStyle } from '@chegg-wt/core/utils/styles'
import { useOnUnloadTimeOnPage } from '@chegg/time-on-page'
import upgradeCopy, { upgradePromotionCopy } from '../../copy/upgrade'
import { findPageCredibility } from '../../copy/credibility'

interface SourceSearchPageProps {
  currentStyle: string
  isLvp: boolean
}

const SourceSearchPage: NextPageWithLayout<SourceSearchPageProps> = ({
  currentStyle,
  isLvp,
}) => {
  const { source } = useRouter().query as { source: string }
  const formattedStyle = getCapitalizedSEONameOfStyle(getUrlStyle(currentStyle))
  useOnUnloadTimeOnPage()

  return (
    <>
      <SEOTitle
        title={`How to Reference a ${getSourceTypeName(
          source
        )} in ${formattedStyle} | Cite This For Me`}
      />
      {!isLvp && (
        <TopContentWrapper>
          <SourceSearchPageStructureTop currentSourceType={source} />
        </TopContentWrapper>
      )}
      <SourceSearch
        copy={{
          upgradeCopy,
          considerCredibility: findPageCredibility,
          upgradePromotionCopy,
        }}
        initialSourceType={source}
      />
    </>
  )
}

SourceSearchPage.getPageLayout = (page) =>
  getLvpLayout(page, () => {
    const { source } = useRouter().query as { source: string }
    return <SourceSearchPageStructureTop currentSourceType={source} />
  })

const mapStateToProps = (state: AppState) => ({
  currentStyle: currentStyleSelector(state),
  isLvp: lvpLayoutSelector(state),
})

export default connect(mapStateToProps)(SourceSearchPage)
